import applicationTitles from "./applicationTitles";
import assessmentPlaceApplicationTitles from "./assessmentPlaceApplicationTitles";

const applicationTitleService = [
    {
        matcher: 'applicationTitles',
        reply: config => {
            return [200, applicationTitles];
        }
    },
    {
        matcher: 'assessmentPlaceApplicationTitles',
        reply: config => {
            return [200, assessmentPlaceApplicationTitles];
        }
    }
]

export default applicationTitleService;